import { mockComponentRenderProp } from 'bloko/common/setupMockComponents';

const { DownPlacement, DownLayer } = jest.requireActual('bloko/blocks/drop/Down/Click.js');
export { DownPlacement, DownLayer };

export default mockComponentRenderProp('DropDownClick', null, {
    withChildren: true,
});
